import React, { Component } from "react";

import Header from "@components/Header";

class TipsAndTricks extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>TipsAndTricks</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default TipsAndTricks;
